import { IDecision, clone, EModalType, IBranch } from '../../helpers/';
import { DEFAULT_DECISION } from '../../constants';
import types from '../types';

export interface IDecisionConfigState {
    decision: IDecision;
    componentId: string;
    previousOutputBlocks: any;
    branchEditIndex: number;
    editedBranch: IBranch;
}

export const initialState: IDecisionConfigState = {
    decision: clone(DEFAULT_DECISION),
    componentId: null,
    previousOutputBlocks: {},
    branchEditIndex: null,
    editedBranch: null
};

const decisionConfigReducer = function(state: IDecisionConfigState = initialState, action): IDecisionConfigState {

	let stateClone: IDecisionConfigState = clone(state);

	switch(action.type) {

		case types.UPDATE_DECISION_DIALOG:
			stateClone = updateDecisionDialog(stateClone, action.decision);
			break;

        case types.TOGGLE_DIALOG:
            stateClone = toggleDialog(stateClone, action.openModal, action.componentId, action.decision, action.previousOutputBlocks);
            break;		

		case types.ADD_BRANCH:
			stateClone = addBranch(stateClone, action.componentId, action.branch);
			break;            

        case types.DELETE_BRANCH:
            stateClone = deleteBranch(stateClone, action.componentId, action.branchIndex);
            break;

        case types.SET_BRANCH_EDIT_INDEX:
            stateClone = setBranchEditIndex(stateClone, action.branchIndex);
            break;

        case types.SAVE_EDITED_BRANCH:
            stateClone = saveEditedBranch(stateClone);
            break;

        case types.UPDATE_EDITED_BRANCH:
            stateClone = updateEditedBranch(stateClone, action.editedBranch);
            break;

        case types.UPDATE_DECISION_BRANCH_RULE_WITH_OUTPUTS:
            stateClone = updateDecisionBranchRuleFromOutputs(stateClone, action.editedBranch);
            break;

		default: 
			break;

	}

	return stateClone;

};

const updateDecisionDialog = (state: IDecisionConfigState, decision: IDecision): IDecisionConfigState => {
	state.decision = decision;
	return state;
};

const toggleDialog = (state: IDecisionConfigState, openModal: EModalType, componentId: string, decision: IDecision, previousOutputBlocks: any): IDecisionConfigState => {

    if(openModal === EModalType.DecisionConfig) {

        state.decision = decision;
        state.componentId = componentId;
		state.previousOutputBlocks = previousOutputBlocks;

    }

    return state;

};

const addBranch = (state: IDecisionConfigState, componentId: string, branch: IBranch): IDecisionConfigState => {
    state.decision.Branches.push(branch);
    return state;
};

const deleteBranch = (state: IDecisionConfigState, componentId: string, branchIndex: number): IDecisionConfigState => {
    state.decision.Branches.splice(branchIndex, 1);
    return state;
};

const setBranchEditIndex = (state: IDecisionConfigState, branchIndex: number): IDecisionConfigState => {
    state.branchEditIndex = branchIndex;
    state.editedBranch = branchIndex == null ? null : clone(state.decision.Branches[branchIndex]);
    return state;
}

const saveEditedBranch = (state: IDecisionConfigState) => {
    state.decision.Branches[state.branchEditIndex] = state.editedBranch;
    state.branchEditIndex = null;
    state.editedBranch = null;
    return state;
}

const updateEditedBranch = (state: IDecisionConfigState, editedBranch: IBranch) => {
    state.editedBranch = editedBranch;
    return state;
} 

const updateDecisionBranchRuleFromOutputs = (state: IDecisionConfigState, editedBranch: IBranch) => {
    state.editedBranch = editedBranch;
    return state;
} 

export default decisionConfigReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/decision-config.ts